export const getFormattedMemberBalance = (i18n, displayText, units, unitName) => i18n.template(displayText.memberBalanceFormat, {
    units,
    unitName: unitName !== null && unitName !== void 0 ? unitName : displayText.defaultBalanceTypeUnitName
});
